import React from "react";
import {useTranslation} from "react-i18next";
import CustomTooltip from "../../CustomTooltip";
import {DeleteIcon} from "../../../assets/icons/Icons";
import {Link} from "react-router-dom";
import CustomSelect from "../../form/CustomSelect";
import { getPaymentTypeOptions } from "../../../config/paymentTypeOptions";

const PaymentRow = ({ rowIndex, rowData, onFieldChange, removeRow }) => {

    const { t } = useTranslation();

    const availablePaymentCards = getPaymentTypeOptions(t);


    return (
        <>
            <td>
                <CustomSelect
                    placeholder={<div>Select card</div>}
                    options={availablePaymentCards}
                    value={rowData.payment_type}
                    onChange={(e) => {
                        onFieldChange("payment_type", e)
                    }}
                />
            </td>
            <td>
                <input
                    type="text"
                    maxLength="255"
                    placeholder={t("Confirmation Code")}
                    value={rowData.confirmation_code || ""}
                    onChange={ (e) => {
                        onFieldChange("confirmation_code", e.target.value);
                    }}
                />
            </td>
            <td>
                <input
                    type="number"
                    placeholder={t("Amount")}
                    value={rowData.amount || ""}
                    onChange={ (e) => {
                        if ( e.target.value >= 0) {
                            onFieldChange("amount", e.target.value);
                        }
                    }}
                    onWheel={(e) => e.target.blur()}
                    onKeyDown={(e) => { if (e.key === 'ArrowUp' || e.key === 'ArrowDown') e.preventDefault(); }}
                />
            </td>
            <td className="text-center">
                <Link to="#" onClick={e => {e.preventDefault(); removeRow(rowIndex)}}>
                    <CustomTooltip icon={<DeleteIcon/>} message={t("Remove Row")}/>
                </Link>
            </td>
        </>
    );
};

export default PaymentRow;
